import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel({ value, currentStep, totalSteps, isDeterminate }) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', marginTop: 3  }}>
      <CircularProgress variant={isDeterminate ? 'determinate' : 'indeterminate'} value={value} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {isDeterminate && (
          <Typography
            variant="caption"
            component="div"
            sx={{ color: 'text.secondary' }}
          >
            {`${currentStep}/${totalSteps}`}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default function KycCircularProgress({ duration = 10000 }) {
  const [progress, setProgress] = React.useState(0);
  const [isDeterminate, setIsDeterminate] = React.useState(true);
  const totalSteps = 10; // Assume 10 steps for the progress

  React.useEffect(() => {
    let timer;

    if (isDeterminate) {
      setProgress(0); // Reset progress when switching to determinate
      const intervalTime = duration / totalSteps; // Duration divided into steps
      
      timer = setInterval(() => {
        setProgress((prevProgress) => {
          const newProgress = prevProgress + 1;
          if (newProgress >= totalSteps) {
            clearInterval(timer); // Stop when progress reaches total steps
            setIsDeterminate(false); // Switch to indeterminate mode
            return totalSteps; // Ensure progress stays at the last step
          }
          return newProgress;
        });
      }, intervalTime);
    }

    return () => {
      clearInterval(timer); // Cleanup interval on unmount or switching modes
    };
  }, [isDeterminate, duration]);

  return (
    <CircularProgressWithLabel 
      value={(progress / totalSteps) * 100} 
      currentStep={progress} 
      totalSteps={totalSteps} 
      isDeterminate={isDeterminate}
    />
  );
}